import { useEffect } from "react"
import Prism from "prismjs"
import hljs from "highlight.js"
import "highlight.js/styles/github-dark.css"

export const ActivatePrism = () => {
  useEffect(() => {
    // call the highlightAll() function to style our code blocks

    // hljs.registerLanguage("python", pytho)

    Prism.highlightAll()
    hljs.highlightAll()
  }, [])
  return null
}
